import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import globalMU from "../../../../globalMU";
const estiloAbaTiposEntrega = require("./aba-tipo-entrega.module.scss").default;
const estiloTabela = require('../../../estilos/tabelas.module.scss').default;

export type TipoEntrega = {
  "Carga": string,
  "Codigo": string,
  "CodigoObjetoItem": number,
  "Descricao": string,
  "DescricaoTipoEntrega": string,
  "OpcaoEntrega": string,
  "PesoTotal": number,
  "Quantidade": number,
  "TipoEntrega": string,
  "UserMessage"?: string,
  "Transforming": boolean
};

export type AbaTipoEntregaProps = {
  tiposEntrega: TipoEntrega[];
  onEditarTipoEntrega: (tipoEntrega: TipoEntrega) => void;
  permitidoEditar: boolean
  mostrarNomeComoCodigo: boolean
};

export const AbaTipoEntrega = (props: AbaTipoEntregaProps) => {
  return props.tiposEntrega?.length > 0 &&
    <div className={estiloTabela.containerRolavel}>
      <table className={estiloTabela.tabela} style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>{props.mostrarNomeComoCodigo ? "Código" : "Referência"}</th>
            <th>Descrição</th>
            <th>Quantidade</th>
            <th>Tipo Entrega</th>
            <th>Opção Entrega</th>
            <th>Carga</th>
            <th>Peso Total</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {(props.tiposEntrega || [])?.map((tipoEntrega) => (
            <tr key={tipoEntrega.CodigoObjetoItem}>
              <td className="_text-center">{tipoEntrega.Codigo}</td>
              <td>{tipoEntrega.Descricao}</td>
              <td>{globalMU.formatarValorNumerico(tipoEntrega.Quantidade, 3, false)}</td>
              <td>{tipoEntrega.DescricaoTipoEntrega}</td>
              <td>{tipoEntrega.OpcaoEntrega}</td>
              <td>{tipoEntrega.Carga}</td>
              <td>{globalMU.formatarValorNumerico(tipoEntrega.PesoTotal, 3, false)}</td>
              <td>
                {
                  props.permitidoEditar &&
                  <FontAwesomeIcon
                    className={estiloAbaTiposEntrega.icone_editar}
                    icon={faPenToSquare}
                    onClick={(e) => {
                      props.onEditarTipoEntrega(tipoEntrega);
                      e.stopPropagation();
                    }}
                  />
                }
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      {<section style={{ marginBottom: "30px" }} />}
    </div>
};
